import { useState, useEffect } from 'react';

export const BP = { mobile: 768, tablet: 1024 };

function getSize() {
  if (window.matchMedia(`(max-width: ${BP.mobile - 1}px)`).matches) {
    return { width: BP.mobile - 1, height: window.innerHeight };
  }
  if (window.matchMedia(`(max-width: ${BP.tablet - 1}px)`).matches) {
    return { width: BP.mobile, height: window.innerHeight };
  }
  return { width: BP.tablet, height: window.innerHeight };
}

export function useWindowSize() {
  const [size, setSize] = useState(getSize);

  useEffect(() => {
    const handler = () => setSize(getSize());
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  return size;
}
